import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { getMessageGroupSummary } from "../actions/messageGroups.actions";
import { messageGroupsQueryKeys } from "../messageGroups.queryKeys";
import { MessageGroupSummary } from "../messageGroups.types";

export const useMessageGroupSummaryQuery = ({ groupUid, companyId }: { groupUid?: string; companyId?: number | string | null }) => {
  const token = sessionStorage.getItem("token");
  const activeCompanyId = useSelector((state: any) => state.userState.activeCompanyId);
  const effectiveCompanyId = companyId ?? activeCompanyId;

  return useQuery<MessageGroupSummary>({
    queryKey: messageGroupsQueryKeys.summary(effectiveCompanyId, groupUid),
    queryFn: () => getMessageGroupSummary(token, groupUid as string, effectiveCompanyId),
    enabled: Boolean(token && effectiveCompanyId && groupUid),
    refetchOnWindowFocus: false,
  });
};
